import { DryDocking } from '../../types/ViewModel/Vessel/DryDocking';
import { DryDockingBM } from '../../types/BusinessModel/Vessel/DryDockingBM';

export class DryDockingFactory {
    constructor() {}
    public getDryDocking(dd: DryDockingBM | null): DryDocking | null {
        if (dd) {
            return new DryDocking(dd.plannedDate, dd.type, dd.days, dd.yardArea, dd.bsDueDate, dd.bwtsDueDate, dd.comments, dd.dataSource);
        }
        return null;
    }
}
